import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "search-shell"
};
const _hoisted_2 = {
  class: "search-toolbar"
};
const _hoisted_3 = {
  class: "search-input-wrap"
};
const _hoisted_4 = {
  class: "results-toolbar"
};
const _hoisted_5 = {
  class: "results-count"
};
const _hoisted_6 = {
  key: 0,
  class: "state-card"
};
const _hoisted_7 = {
  class: "loading-state"
};
const _hoisted_8 = {
  key: 0,
  class: "results-area"
};
const _hoisted_9 = {
  key: 1,
  class: "state-card"
};
const _hoisted_10 = {
  class: "empty-state"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_search_chips = _resolveComponent("search-chips");
  const _component_b_button = _resolveComponent("b-button");
  const _component_b_form = _resolveComponent("b-form");
  const _component_b_pagination = _resolveComponent("b-pagination");
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_video_list = _resolveComponent("video-list");
  const _component_b_modal = _resolveComponent("b-modal");
  return _openBlock(), _createBlock(_component_b_modal, {
    id: "search-modal",
    title: "Search Network",
    "no-footer": "",
    size: "xl",
    "no-close-on-backdrop": "",
    "modal-class": "sbn-search-modal",
    "content-class": "sbn-search-modal-content",
    "header-class": "sbn-search-modal-header",
    "body-class": "sbn-search-modal-body"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_b_form, {
      onSubmit: _withModifiers($options.performSearch, ["prevent"]),
      class: "search-form"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_search_chips, {
        ref: "chips",
        modelValue: $data.searchTerms,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.searchTerms = $event),
        placeholder: "Search Network (press space or enter after each word)",
        disabled: $data.loading,
        onSearch: $options.onChipsSearch
      }, null, 8, ["modelValue", "disabled", "onSearch"])]), _createVNode(_component_b_button, {
        type: "submit",
        class: "search-btn",
        disabled: $data.loading
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" Search ", -1)]))], undefined, true),
        _: 1
      }, 8, ["disabled"])], undefined, true),
      _: 1
    }, 8, ["onSubmit"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[4] || (_cache[4] = _createTextVNode(" Total Results: ", -1)), _createElementVNode("strong", null, _toDisplayString($data.totalRows), 1)]), $data.totalRows > $data.perPage ? (_openBlock(), _createBlock(_component_b_pagination, {
      key: 0,
      modelValue: $data.currentPage,
      "onUpdate:modelValue": [_cache[1] || (_cache[1] = $event => $data.currentPage = $event), $options.onPageChange],
      "total-rows": $data.totalRows,
      "per-page": $data.perPage,
      pills: "",
      align: "right",
      class: "search-pagination"
    }, null, 8, ["modelValue", "total-rows", "per-page", "onUpdate:modelValue"])) : _createCommentVNode("", true)]), $data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_b_spinner, {
      small: "",
      class: "me-2"
    }), _cache[5] || (_cache[5] = _createElementVNode("span", null, "Loading videos...", -1))])])) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [$data.searchResults.length ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_video_list, {
      onPlay: _cache[2] || (_cache[2] = $event => $options.routeToSubscribe()),
      displayType: 'grid',
      preview: true,
      videoObject: {
        results: $data.searchResults
      }
    }, null, 8, ["videoObject"])])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[6] || (_cache[6] = _createElementVNode("div", {
      class: "empty-icon"
    }, [_createElementVNode("svg", {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [_createElementVNode("circle", {
      cx: "11",
      cy: "11",
      r: "8"
    }), _createElementVNode("line", {
      x1: "21",
      y1: "21",
      x2: "16.65",
      y2: "16.65"
    })])], -1)), _createElementVNode("h5", null, _toDisplayString($data.searchTerms.length ? 'No results found' : 'Start a search'), 1), _createElementVNode("p", null, _toDisplayString($data.searchTerms.length ? 'Try removing a chip or using a different keyword.' : 'Type a word and press space or enter to add it as a chip.'), 1)])]))], 64))])], undefined, true),
    _: 1
  });
}